import { render, staticRenderFns } from "./RoleRightList.vue?vue&type=template&id=54892c30&scoped=true&"
import script from "./RoleRightList.vue?vue&type=script&lang=js&"
export * from "./RoleRightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54892c30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54892c30')) {
      api.createRecord('54892c30', component.options)
    } else {
      api.reload('54892c30', component.options)
    }
    module.hot.accept("./RoleRightList.vue?vue&type=template&id=54892c30&scoped=true&", function () {
      api.rerender('54892c30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/auth/RoleRightList.vue"
export default component.exports